import { render, staticRenderFns } from "./BrandTile.vue?vue&type=template&id=be42c058&scoped=true&"
import script from "./BrandTile.vue?vue&type=script&lang=ts&"
export * from "./BrandTile.vue?vue&type=script&lang=ts&"
import style0 from "./BrandTile.vue?vue&type=style&index=0&id=be42c058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be42c058",
  null
  
)

export default component.exports